import './App.css';
import NavBar from './NavBar';
import Footer from './components/Footer';
import { AuthProvider } from './AuthContext';
import HomePage from './pages/HomePage';
import AboutDigitization from './pages/AboutDigitization';
import AboutTeam from './pages/AboutTeam';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import PasswordResetPage from './pages/PasswordResetPage';
import DashboardPage from './pages/DashboardPage';
import BulkUploadPage from './pages/BulkUploadPage';
import LogDetailPage from './pages/LogDetailPage';
import LasFilesPage from './pages/LasFilesPage';
import QcViewPage from './pages/QcViewPage';
import AdminLogsPage from './pages/AdminLogsPage';
import AdminReviewPage from './pages/AdminReviewPage';
import Temp_Signup_Redirect from './pages/Temp_Signup_Redirect';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AboutTaxes from './pages/AboutTaxes';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App" style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
          <NavBar />
          <main style={{ flex: '1 0 auto', background: '#000', color: '#fff' }}>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/digitization" element={<AboutDigitization />} />
              <Route path="/adval_taxes" element={<AboutTaxes />} />
              <Route path="/team" element={<AboutTeam />} />
              <Route path="/login" element={<LoginPage />} />

              <Route path="/signup" element={<SignupPage />} />
              <Route path="/temp-signup" element={<Temp_Signup_Redirect />} />

              <Route path="/reset" element={<PasswordResetPage />} />
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/bulk-upload" element={<BulkUploadPage />} />
              <Route path="/logs/:id" element={<LogDetailPage />} />
              <Route path="/logs/:id/las-files" element={<LasFilesPage />} />
              <Route path="/logs/:id/qc" element={<QcViewPage />} />
              <Route path="/admin/logs" element={<AdminLogsPage />} />
              <Route path="/admin/logs/:id" element={<AdminReviewPage />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;

